"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var constants = {
  INTERESTS: {
    CRITICAL_CUTOFF: 4,
    CRITICAL_PENALTY: 15,
    CRITICAL_BOOST: 0,
    DEFAULT: 5
  },
  SKILLS: {
    MISSING_CRITICAL_SKILL_PENALTY: -50,
    MISSING_SKILL_PENALTY: 0,
    JOB_SKILL_NOT_PRESENT_PENALTY: -10,
    USER_AND_JOB_SKILL_MATCH_BOOST: 100
  },
  EDUCATION: {
    DEFAULT_VALUE: 0,
    HIGH_SCHOOL_VALUE: 1,
    CERTIFICATE_VALUE: 2,
    ASSOCIATE_VALUE: 3,
    BACHELOR_VALUE: 4,
    MASTER_VALUE: 5,
    GREATER_EDUCATION_BOOST: 0.2,
    MISSING_EDUCATION_PENALTY: 0.5
  }
};

exports.default = constants;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/utils/match/constants.js
// module id = 187
// module chunks = 0